'use strict';

/**
 * @extends {ngtk.model.Base}
 */
ngtk.model.List = ngtk.model.Base.extend({

    _items: undefined,
    _itemModel: undefined,
    _itemsScopeData: undefined,
    _deps: {},

    _initialize: function() {
        this._items = {};
        this._itemsScopeData = [];
    },

    clean: function() {
        this._clean();
        this._updateItemsScopeData();
        return this;
    },

    _clean: function () {
        this._cleanObject('_items');
        return this;
    },

    forEach: function(cb) {
        angular.forEach(this._items, cb);
    },

    get: function(id) {
        return this._items[id];
    },

    set: function(id, item) {
        this._set(id, item);
        this._updateItemsScopeData();
        return this;
    },

    _set: function(id, item) {
        var itemModel;
        if (item instanceof this._itemModel) {
            itemModel = item;
        } else {
            itemModel = this._constructItem(item);
            itemModel.replace(item);
        }
        if (angular.isUndefined(id)) {
            id = this._extractIdFromItemData(itemModel._data);
        }
        var $$idx = undefined;
        if (this._items[id]) {
            $$idx = this._items[id].$$idx;
        }
        this._items[id] = itemModel;
        if (angular.isUndefined($$idx)) {
            $$idx = this.getLength() - 1;
        }
        this._items[id].$$idx = $$idx;
        return $$idx;
    },

    exportObject: function() {
        return this._items;
    },

    unset: function(id) {
        if (angular.isDefined(this._items[id])) {
            var idx = this._items[id].$$idx;
            delete this._items[id];
            if (angular.isDefined(idx)) {
                angular.forEach(this._items, function(value) {
                    if (angular.isDefined(value.$$idx) && value.$$idx > idx) {
                        value.$$idx--;
                    }
                });
            }
            this._updateItemsScopeData();
        }
        return this;
    },

    getLength: function() {
        return Object.keys(this._items).length;
    },

    merge: function(items) {
        var detectIds = '0' in items;
        angular.forEach(items, function(item, id) {
            this._set(detectIds ? undefined : id, item);
        }.bind(this));
        this._updateItemsScopeData();
        return this;
    },

    replace: function(items) {
        this._clean();
        return this.merge(items);
    },

    _wireScope: function(scope, scopeInnerPtr, scopeInnerElement) {
        if (angular.isUndefined(scopeInnerPtr[scopeInnerElement])) {
            scopeInnerPtr[scopeInnerElement] = {};
        }
        scopeInnerPtr[scopeInnerElement]['items'] = this._itemsScopeData;
        scopeInnerPtr[scopeInnerElement].$model = this;
    },

    _setFromApiResult: function(itemDataArray, merge) {
        if (!merge) {
            this._clean();
        }
        angular.forEach(itemDataArray, function(itemData) {
            var id = this._extractIdFromItemData(itemData);
            if (!id) {
                console.warn('Could not extract itemData id', itemData);
            } else {
                var item = this._constructItem(itemData);
                item._setFromApiResult(itemData);
                this._set(id, item);
            }
        }.bind(this));
        this._updateItemsScopeData();
    },

    _updateItemsScopeData: function() {
        this._itemsScopeData.length = 0;
        angular.forEach(this._items, function(item) {
            this._itemsScopeData[item.$$idx] = item.exportData();
            this._itemsScopeData[item.$$idx].$model = item;
        }.bind(this));
    },

    _constructItem: function(itemData) {
        return this._modelFactory.create(this._itemModel, this._deps);
    },

    _extractIdFromItemData: function(itemData) {
        return this._itemModel.prototype._extractIdFromItemData(itemData);
    }

});
